const BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Shared fetch wrapper that throws a descriptive error on non-2xx responses.
 * @param {string} url
 * @returns {Promise<unknown>}
 */
const apiFetch = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(
      `API request failed: ${response.status} ${response.statusText} — ${url}`
    );
  }

  return response.json();
}

/**
 * Fetch a page of published blog posts.
 * @param {number} [page=1] - 1-based page number.
 * @returns {Promise<{ posts: Array<object>, meta: { current_page: number, total_pages: number, total_count: number, per_page: number } }>}
 */
export async function fetchPosts(page = 1) {
  return apiFetch(`${BASE_URL}/api/v1/posts?page=${page}`);
}

/**
 * Fetch a single blog post by its slug.
 * @param {string} slug
 * @returns {Promise<object>}
 */
export async function fetchPost(slug) {
  return apiFetch(`${BASE_URL}/api/v1/posts/${slug}`);
}
